module.exports = __webpack_public_path__ + "static/gt-map-536e716e0c5522697c12d07e068d2f0a.png";